import React, { useEffect } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { IconCrossSmall } from '@sololearnorg/sol';
import { Container } from '../../../../symphony';

import {
	SlDiscussContext,
	getAddAnswerMessage,
	getEditAnswerMessage,
} from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './ReplyFormSuccessMessage.scss';

export function ReplyFormSuccessMessage() {
	useStyles(s);
	const { actions$ } = Container.take(SlDiscussContext, SlActions);
	const {
		isVisibleCreateReplySuccessMessage$: isVisibleCreateReplySuccessMessage,
		isVisibleEditReplySuccessMessage$: isVisibleEditReplySuccessMessage,
	} = useContainerData(SlDiscussContext, SlDataService, [
		'isVisibleCreateReplySuccessMessage$',
		'isVisibleEditReplySuccessMessage$',
	]);

	const messageCloseClickHandler = () => {
		actions$.next({
			type: ActionType.OnCloseSaveReplySuccessMessage,
			requestType: RequestType.Parallel,
		});
	};

	useEffect(() => {
		if (
			isVisibleCreateReplySuccessMessage
			|| isVisibleEditReplySuccessMessage
		) {
			setTimeout(() => {
				actions$.next({
					type: ActionType.OnCloseSaveReplySuccessMessage,
					requestType: RequestType.Parallel,
				});
			}, 2000);
		}
	}, [isVisibleCreateReplySuccessMessage, isVisibleEditReplySuccessMessage]);

	return isVisibleCreateReplySuccessMessage
		|| isVisibleEditReplySuccessMessage ? (
			<div className="discuss-reply-form-success-message">
				<div className="discuss-reply-form-success-message__content">
					{isVisibleCreateReplySuccessMessage
						? getAddAnswerMessage()
						: getEditAnswerMessage()}
				</div>
				<IconCrossSmall
					className="discuss-reply-form-success-message__close-icon"
					onClick={messageCloseClickHandler}
				/>
			</div>
		) : null;
}
